import { SendHorizonal } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MAX_MESSAGE_CHARS } from "@/features/assistant/constants";
import type { QuotaError } from "@/features/assistant/types";

interface Props {
  disabled?: boolean;
  quota: QuotaError | null;
  onSend: (content: string) => void;
}

export function Composer({ disabled = false, quota, onSend }: Props) {
  const [value, setValue] = useState("");
  const blocked = disabled || quota !== null;
  const canSend =
    !blocked && value.trim().length > 0 && value.length <= MAX_MESSAGE_CHARS;

  const submit = () => {
    if (!canSend) return;
    onSend(value.trim());
    setValue("");
  };

  return (
    <div className="border-t p-3">
      {quota && (
        <p
          className="mb-2 text-xs text-destructive"
          data-testid="assistant-quota-notice"
        >
          Limite diário de {quota.limit} perguntas atingido. Renova em{" "}
          {new Date(quota.resets_at).toLocaleString("pt-BR", {
            hour: "2-digit",
            minute: "2-digit",
            day: "2-digit",
            month: "2-digit",
          })}
          .
        </p>
      )}
      <div className="flex items-end gap-2">
        <Textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              submit();
            }
          }}
          placeholder="Pergunte sobre a sua frota…"
          rows={2}
          maxLength={MAX_MESSAGE_CHARS}
          disabled={blocked}
          className="min-h-[44px] resize-none text-base"
          data-testid="assistant-composer-input"
        />
        <Button
          size="icon"
          onClick={submit}
          disabled={!canSend}
          aria-label="Enviar"
          data-testid="assistant-send"
        >
          <SendHorizonal className="h-4 w-4" />
        </Button>
      </div>
      <p className="mt-1 text-right text-[11px] text-muted-foreground">
        {value.length}/{MAX_MESSAGE_CHARS}
      </p>
    </div>
  );
}
